/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Quota_Badge_IncludedInputs */

const fr_calendar_quota_badge_included = /** @type {(inputs: Calendar_Quota_Badge_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclus`)
};

/**

* @param {Calendar_Quota_Badge_IncludedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_badge_included = /** @type {((inputs?: Calendar_Quota_Badge_IncludedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Badge_IncludedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_badge_included(inputs)
});